import {modalAlert} from "./modules/modalAlert.js";
import {APIRequest} from "./modules/APIRequest.js";

// Shared behavior for every admin page.
(async ()=>{
	'use strict';
	window.HELP_IMPROVE_VIDEOJS = false;

	$(document).on('click', 'a[data-alert-message]', function (e) {
		e.preventDefault();
		var message = $(this).data('alert-message');
		var title = $(this).data('alert-title') || 'Notice';
		modalAlert(message, title);
	});

	$(document).on('click', '[data-cc-text]', async function (e) {
		e.preventDefault();
		await navigator.clipboard.writeText($(this).data('cc-text'));
		await modalAlert('Link copied to clipboard!');
	});

	// Nested dropdown menus
	$('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
		if (!$(this).next().hasClass('show')) {
			$(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
		}
		var $subMenu = $(this).next('.dropdown-menu');
		$subMenu.toggleClass('show');

		$(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
			$('.dropdown-submenu .show').removeClass('show');
		});

		return false;
	});

	// Close the sidebar if viewport is less than 600px wide
	if (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 600) {
		document.body.classList.add('sidebar-toggled');
		document.querySelectorAll('.sidebar').forEach(sb => {
			sb.classList.add('toggled');
		});
	}

	// Only logged-in pages have the top bar; skip the session ping elsewhere.
	if (!document.getElementById('topbar-messages-dd')) return;

	// Keep the session alive and show the unread-message count. If the session
	// has ended, go back to the landing page.
	async function refreshSession() {
		var request = new APIRequest();
		request.set('getSession');
		var result = (await request.send()).getSession;
		if (!result || (result.errors && result.errors.length) || !result.data) {
			location.href = 'index.php';
			return;
		}
		var unread = +result.data.unread_messages || 0;
		$("#topbar-messages-dd").html(`<i class="fas fa-envelope fa-fw"></i>` +
			(unread ? `<span class="badge badge-danger badge-counter">${unread}</span>` : ''));
	}

	refreshSession();
	setInterval(refreshSession, 60 * 1000);

})();
